import React, { useEffect, useState } from "react";
import {
	CheckboxUnit,
	DBFilterCheckboxArea,
	DBFilterDateArea,
	DBFilterWrapper,
	DBTableBtn,
	DBTableExcelBtn,
	DBTableResultTxt,
	ShowBlock,
	ShowWrapper,
} from "./styles";
import { Icon } from "../Main/styles";
import { FaRegFileExcel } from "react-icons/fa";
import { TopBoxTitle } from "../Home/styles";
import { Checkbox, message, Table } from "antd";
import { useCustomerList } from "CRM/hooks/GetCustomerTable";
import { FaDollarSign, FaPen, FaRegAddressCard, FaRegIdCard } from "react-icons/fa6";
import { IoMdCloseCircleOutline } from "react-icons/io";
import CustomerInfo from "CRM/components/DB/CustomerInfo";
import CustomerDeposit from "CRM/components/DB/CustomerDeposit";
import API from "utils/api";
import { useToken } from "app/hooks";
import { useUserInfo } from "CRM/hooks/GetUserInfo";
import { useUserMemo } from "CRM/hooks/GetUserMemo";
import { useIsMobile } from "../../components/IsMobile";
import { useMyInfo } from "CRM/hooks/GetMyInfo";

export const CustomerTable = ({
	platformList,
	pathList,
	resList,
	teamList,
	depositedAt,
	createdAt,
	assignedAt,
	updatedAt,
	name,
	tel,
	path,
	respon,
	team,
	platform,
}) => {
	const IsMobile = useIsMobile();
	const [scrollPosition, setScrollPosition] = useState(0);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const { myInfo } = useMyInfo();
	const { customerList, total, mutate } = useCustomerList(
		platform == "" ? "" : platformList?.find((it) => it.name == platform)?.id,
		team == "" ? "" : teamList?.find((it) => it.name == team)?.id,
		respon == "" ? "" : resList?.find((it) => it.name == respon)?.id,
		depositedAt?.[0] == null ? "" : `${depositedAt?.[0]?.format("YYYY-MM-DD") + "~" + depositedAt?.[1]?.format("YYYY-MM-DD")}`,
		createdAt?.[0] == null ? "" : `${createdAt?.[0]?.format("YYYY-MM-DD") + "~" + createdAt?.[1]?.format("YYYY-MM-DD")}`,
		assignedAt?.[0] == null ? "" : `${assignedAt?.[0]?.format("YYYY-MM-DD") + "~" + assignedAt?.[1]?.format("YYYY-MM-DD")}`,
		updatedAt?.[0] == null ? "" : `${updatedAt?.[0]?.format("YYYY-MM-DD") + "~" + updatedAt?.[1]?.format("YYYY-MM-DD")}`,
		name,
		tel,
		path == "" ? "" : pathList?.find((it) => it.name == path)?.id,
		page,
		pageSize
	);
	const { data: token } = useToken();
	const [selectedRows, setSelectedRows] = useState<number[]>([]);
	const [isAllChecked, setIsAllChecked] = useState(false);

	const [isShow, setIsShow] = useState(null);
	const [isUserSelect, setIsUserSelect] = useState(false);
	const [userId, setUserId] = useState();
	const [isPayment, setIsPayment] = useState(false);

	const { userInfo, mutate: userMutate } = useUserInfo(userId);
	const { userMemoList, mutate: memoMutate } = useUserMemo(userId);

	useEffect(() => {
		if (IsMobile) {
			if (isUserSelect || isPayment) {
				window.scrollTo({ top: 0, behavior: "smooth" });
				setScrollPosition(window.scrollY);
			} else {
				window.scrollTo({ top: scrollPosition, behavior: "smooth" });
			}
		}
	}, [isUserSelect, isPayment]);

	useEffect(() => {
		if (userId !== null) {
			userMutate();
		}
	}, [userId]);

	useEffect(() => {
		const allSelected = customerList?.length > 0 && customerList?.every((it) => selectedRows?.includes(it.id));
		setIsAllChecked(allSelected);
	}, [selectedRows, customerList]);

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setSelectedRows([...selectedRows, id]);
		} else {
			setSelectedRows(selectedRows?.filter((rowId) => rowId !== id));
		}
	};

	const handleSelectAllChange = (e) => {
		setIsAllChecked(e.target.checked);
		const ids = customerList?.map((db) => db.id);
		setSelectedRows(e.target.checked ? [...selectedRows, ...ids] : []);
	};

	const excelDownAll = () => {
		const shouldEdit = window.confirm(`전체 고객 DB를 다운받으시겠습니까?`);
		if (shouldEdit) {
			API.post(
				"/transaction?page=1&maxData=99999999" +
					"&teamId=" +
					(team == "" ? "" : teamList?.find((it) => it.name == team)?.id) +
					"&responsibilityId=" +
					(respon == "" ? "" : resList?.find((it) => it.name == respon)?.id) +
					"&depositedAt=" +
					(depositedAt?.[0] == null
						? ""
						: `${depositedAt?.[0]?.format("YYYY-MM-DD") + "~" + depositedAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&createdAt=" +
					(createdAt?.[0] == null ? "" : `${createdAt?.[0]?.format("YYYY-MM-DD") + "~" + createdAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&assignedAt=" +
					(assignedAt?.[0] == null
						? ""
						: `${assignedAt?.[0]?.format("YYYY-MM-DD") + "~" + assignedAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&updatedAt=" +
					(updatedAt?.[0] == null ? "" : `${updatedAt?.[0]?.format("YYYY-MM-DD") + "~" + updatedAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&customerName=" +
					name +
					"&tel=" +
					tel +
					"&accessPathId=" +
					(path == "" ? "" : pathList?.find((it) => it.name == path)?.id),
				token + "",
				{
					ids: [],
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						window.open(res.result.result.link, "_blank");
					}
				})
				.catch((err: any) => {});
		}
	};

	const excelDownSelect = () => {
		const shouldEdit = window.confirm(`선택한 DB 목록을 다운받으시겠습니까?`);
		if (shouldEdit) {
			API.post(
				"/transaction?page=1&maxData=99999999" +
					"&teamId=" +
					(team == "" ? "" : teamList?.find((it) => it.name == team)?.id) +
					"&responsibilityId=" +
					(respon == "" ? "" : resList?.find((it) => it.name == respon)?.id) +
					"&depositedAt=" +
					(depositedAt?.[0] == null
						? ""
						: `${depositedAt?.[0]?.format("YYYY-MM-DD") + "~" + depositedAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&createdAt=" +
					(createdAt?.[0] == null ? "" : `${createdAt?.[0]?.format("YYYY-MM-DD") + "~" + createdAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&assignedAt=" +
					(assignedAt?.[0] == null
						? ""
						: `${assignedAt?.[0]?.format("YYYY-MM-DD") + "~" + assignedAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&updatedAt=" +
					(updatedAt?.[0] == null ? "" : `${updatedAt?.[0]?.format("YYYY-MM-DD") + "~" + updatedAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&customerName=" +
					name +
					"&tel=" +
					tel +
					"&accessPathId=" +
					(path == "" ? "" : pathList?.find((it) => it.name == path)?.id),
				token + "",
				{
					ids: selectedRows,
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						window.open(res.result.result.link, "_blank");
					}
				})
				.catch((err: any) => {});
		}
	};

	const clickDelete = () => {
		const shouldEdit = window.confirm(`선택한 고객을 삭제하시겠습니까?`);
		if (shouldEdit) {
			if (selectedRows?.length == 0) {
				message.error("선택한 고객이 없습니다.");
			} else {
				API.post("/transaction/delete", token + "", {
					ids: selectedRows,
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("삭제되었습니다.");
							mutate();
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const handleTableChange = (pagination) => {
		setPage(pagination.current);
		setPageSize(pagination.pageSize);
	};

	const mobileColumns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox" style={{ display: "flex", justifyContent: "center" }}>
						<Checkbox
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "거래고객",
			render: (value, data) => {
				// console.log(data)
				return (
					<>
						<div
							className="name"
							onClick={() => setIsShow(data?.id)}
							style={{
								color: "#437EFF",
								cursor: "pointer",
								position: "relative",
								display: "flex",
								justifyContent: "flex-start",
							}}
						>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>이름: </p>
							{data?.name}
							{isShow == data?.id && (
								<ShowWrapper>
									<ShowBlock style={{ backgroundColor: "#437eff", color: "#fff" }}>
										<Icon>
											<FaRegIdCard />
										</Icon>
										{data?.name}
									</ShowBlock>
									<ShowBlock
										onClick={() => {
											setIsUserSelect(true);
											setUserId(data?.userId);
											userMutate();
										}}
									>
										<Icon>
											<FaPen />
										</Icon>
										정보관리
									</ShowBlock>
									<ShowBlock
										onClick={() => {
											setIsPayment(true);
											setUserId(data?.userId);
										}}
									>
										<Icon>
											<FaDollarSign />
										</Icon>
										결제
									</ShowBlock>
									<ShowBlock
										onClick={(e) => {
											e.stopPropagation();
											setIsShow(null);
										}}
									>
										<Icon>
											<IoMdCloseCircleOutline />
										</Icon>
										닫기
									</ShowBlock>
								</ShowWrapper>
							)}
						</div>
						<div className="tel" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>연락처: </p>
							{data?.tel}
						</div>
						<div className="path" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>방문경로: </p> {data?.accessPathName}
						</div>
						<div className="money" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>최종입금액(만원): </p>
							{parseFloat(data?.amount).toLocaleString()}
						</div>
						<div className="money" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>총입금액(만원): </p>{" "}
							{parseFloat(data?.totalAmount).toLocaleString()}
						</div>
						<div className="platform" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>플랫폼: </p>
							{data?.platformName}
						</div>
						<div className="manager" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>담당자: </p>
							{data?.responsibilityName}
						</div>
						<div className="date" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>최종입금일: </p>
							{data?.depositedAt}
						</div>
						<div className="date" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>배정일: </p>
							{data?.assignedAt}
						</div>
						<div className="date" style={{ display: "flex", justifyContent: "flex-start" }}>
							{" "}
							<p style={{ marginRight: 5, fontWeight: "bold", color: "black" }}>등록일: </p>
							{data?.createdAt}
						</div>
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "이름",
			render: (value, data) => {
				// console.log(data)
				return (
					<div
						className="name"
						onClick={() => setIsShow(data?.id)}
						style={{ color: "#437EFF", textDecoration: "underline", cursor: "pointer", position: "relative" }}
					>
						{data?.name}
						{isShow == data?.id && (
							<ShowWrapper>
								<ShowBlock style={{ backgroundColor: "#437eff", color: "#fff" }}>
									<Icon>
										<FaRegIdCard />
									</Icon>
									{data?.name}
								</ShowBlock>
								<ShowBlock
									onClick={() => {
										setIsUserSelect(true);
										setUserId(data?.userId);
										userMutate();
									}}
								>
									<Icon>
										<FaPen />
									</Icon>
									정보관리
								</ShowBlock>
								<ShowBlock
									onClick={() => {
										setIsPayment(true);
										setUserId(data?.userId);
									}}
								>
									<Icon>
										<FaDollarSign />
									</Icon>
									결제
								</ShowBlock>
								<ShowBlock
									onClick={(e) => {
										e.stopPropagation();
										setIsShow(null);
									}}
								>
									<Icon>
										<IoMdCloseCircleOutline />
									</Icon>
									닫기
								</ShowBlock>
							</ShowWrapper>
						)}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "연락처",
			render: (value, data) => {
				return <div className="tel">{data?.tel}</div>;
			},
		},
		{
			dataIndex: "",
			title: "방문경로",
			render: (value, data) => {
				return <div className="path">{data?.accessPathName}</div>;
			},
		},
		{
			dataIndex: "",
			title: "최종입금액(만원)",
			render: (value, data) => {
				return <div className="money">{parseFloat(data?.amount).toLocaleString()}</div>;
			},
		},
		{
			dataIndex: "",
			title: "총입금액(만원)",
			render: (value, data) => {
				return <div className="money">{parseFloat(data?.totalAmount).toLocaleString()}</div>;
			},
		},
		{
			dataIndex: "",
			title: "플랫폼",
			render: (value, data) => {
				return <div className="platform">{data?.platformName}</div>;
			},
		},
		{
			dataIndex: "",
			title: "담당자",
			render: (value, data) => {
				return <div className="manager">{data?.responsibilityName}</div>;
			},
		},
		{
			dataIndex: "",
			title: "최종입금일",
			render: (value, data) => {
				return <div className="date">{data?.depositedAt}</div>;
			},
		},
		{
			dataIndex: "",
			title: "배정일",
			render: (value, data) => {
				return <div className="date">{data?.assignedAt}</div>;
			},
		},
		{
			dataIndex: "",
			title: "등록일",
			render: (value, data) => {
				return <div className="date">{data?.createdAt}</div>;
			},
		},
	];

	return (
		<DBFilterWrapper>
			<DBFilterCheckboxArea IsMobile={IsMobile}>
				{myInfo.master || process.env.REACT_APP_URL?.includes("ccl") ? (
					<>
						{IsMobile ? (
							<CheckboxUnit>
								<DBTableBtn border="green" color="green" onClick={excelDownAll} IsMobile={IsMobile}>
									엑셀다운로드
								</DBTableBtn>
								<DBTableBtn border="green" color="green" onClick={excelDownSelect} IsMobile={IsMobile}>
									선택 다운로드
								</DBTableBtn>
								<DBTableBtn
									border="red"
									color="red"
									onClick={clickDelete}
									style={{ backgroundColor: "#f93e3e", color: "#fff", marginLeft: 20 }}
									IsMobile={IsMobile}
								>
									선택 삭제
								</DBTableBtn>
							</CheckboxUnit>
						) : (
							<CheckboxUnit>
								<DBTableExcelBtn onClick={excelDownAll}>
									<Icon>
										<FaRegFileExcel />
									</Icon>
									엑셀다운로드
								</DBTableExcelBtn>
								<DBTableExcelBtn onClick={excelDownSelect}>
									<Icon>
										<FaRegFileExcel />
									</Icon>
									선택 다운로드
								</DBTableExcelBtn>
								<DBTableExcelBtn
									onClick={clickDelete}
									style={{ backgroundColor: "#f93e3e", color: "#fff", marginLeft: 20 }}
								>
									선택 삭제
								</DBTableExcelBtn>
							</CheckboxUnit>
						)}
					</>
				) : (
					<></>
				)}

				<DBTableResultTxt IsMobile={IsMobile}>
					조회결과: 총 <span>{total || 0}</span> 명
				</DBTableResultTxt>
			</DBFilterCheckboxArea>

			<Table
				dataSource={customerList}
				columns={IsMobile ? mobileColumns : columns}
				bordered={true}
				pagination={{
					current: page,
					pageSize: pageSize,
					total: total,
				}}
				onChange={handleTableChange}
			/>

			{isUserSelect && (
				<CustomerInfo
					setIsUserSelect={setIsUserSelect}
					pathList={pathList}
					resList={resList}
					userInfo={userInfo}
					userMutate={userMutate}
					userMemoList={userMemoList}
					memoMutate={memoMutate}
				/>
			)}
			{isPayment && <CustomerDeposit setIsPayment={setIsPayment} userId={userId} customerList={customerList} platformList={platformList} />}
		</DBFilterWrapper>
	);
};

export default React.memo(CustomerTable);
